module.exports = __webpack_public_path__ + "img/standard.9ee37a1d.png";